module.exports = __webpack_public_path__ + "static/media/logo.5325d6cc.png";